import {
  initializeModule,
  registerStoreModule
} from '@/app/utils/platformUtils';
import router from '@/app/router';
import { setupModuleI18n } from '@/app/i18n';
import store from './store';
import config from './config';

const module = initializeModule(async () => {
  registerStoreModule(store);
  await setupModuleI18n(router.app, 'wrh-dashboard', locale => import(`./locales/${locale}`));
}, config);

export default module.default;
